import { BASE_URL } from 'constants/api';
export const UPLOAD_WORKBOOK_DISPATCH = `${BASE_URL}/workbooks/upload-workbook-dispatched`;

export const FORM_DATA = {
  FILE: 'file',
  MODIFY: 'modify',
  UPLOAD: 'upload',
};

export const ERRORS = 'Errors';
export const ALL_TABS = { UPLOAD_DISPATCH: 'upload-dispatch' };
export const UPLOAD_DISPATCH_TEXT = 'Upload Workbook Dispatched';

export const UPLOADED_FILE_CONTAINS_ERRORS = `No changes were done. The uploaded file contains errors. Please check the downloaded CSV file with 'Errors' column for more details. Please rectify the errors and upload again.`;
export const NOTE_FOR_ERROR_COLUMN = `NOTE: Please delete the errors column before uploading the file. `;
export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const SUCCESSFULLY_SUBMITTED =
  'Successfully submitted. Changes will be reflected in a couple of minutes.';
export const PLEASE_SELECT_FILE = 'Please select file';
export const CSV_CONTENT_TYPE = 'text/csv';
export const CONTENT_TYPE = 'content-type';
export const CONTENT_DISPOSITION = 'content-disposition';
export const POST = 'POST';
export const MULTIPLE_FORM_DATA = 'multipart/form-data';
export const CSV_LINK = 'CSVLink';
